import { StoryInterface } from '../components/story/story.interface';
import { UnifiedStoryResponseModel } from '../../../api/story/model/story-response.model';
import { Observable, of } from 'rxjs';
import { StoryApi } from '../../../api/story/story-api';
import { AmplifyApi } from '../../../api/amplify/amplify-api';
import { UnifiedStoryRequestModel } from '../../../api/story/model/story-request.model';
import { StoryModel } from '../../../api/amplify/model/amplify-reponse.model';
import { SubjectApi } from '../../../api/subject/subject-api';
import { StorySubject } from '../../../api/story/model/story-subject.model';
import { Injectable } from '@angular/core';
import { ArticleViewModel } from '../../../api/amplify/model/amplify-article-model';

@Injectable()
export class Story implements StoryInterface {
    constructor(
        private storyApi: StoryApi,
        private amplifyApi: AmplifyApi,
        private subjectApi: SubjectApi
    ) { }

    getStory(storyId: number): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.getStoryAPI(storyId);
    }

    updateStory(storyId: number, story: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.updateStoryAPI(storyId, story);
    }

    getImage(url: string): Observable<Blob> {
        return this.storyApi.getImage(url);
    }

    createStory(story: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        return this.storyApi.createStoryAPI(story);
    }

    getSubjectList(): Observable<StorySubject[]> {
        return this.subjectApi.getSubjectListAPI();
    }

    getStoryDetail(storyId: number): Observable<StoryModel> {
        return of(null);
    }

    /**
    *  Get article details from Newswire
    */
    getArticleDetailFromNewswire(
        storyId: number
    ): Observable<ArticleViewModel> {
        return this.amplifyApi.getNewswireArticleDetail(storyId);
    }

}
